module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/174-denmark-0e47d99c18fe31323c811109a6eeb797.svg";